import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Image from 'gatsby-image'

import { rhythm } from '../utils/typography'

function Bio() {
  return (
    <StaticQuery
      query={bioQuery}
      render={data => {
        const { author, social } = data.site.siteMetadata
        return (
          <div
            style={{
              display: `flex`
            }}
          >
            <Image
              fixed={data.avatar.childImageSharp.fixed}
              alt={author}
              style={{
                marginRight: rhythm(1 / 2),
                marginBottom: 0,
                minWidth: 50,
                borderRadius: `100%`,
              }}
            />
            <p>
              <strong>{author}</strong> ist Marketing- und Produktmanager bei
              {' '}
              <a href='https://www.speedrank.app'>
                Speedrank
              </a>
              . In diesem Blog
              {' '}
              <a href={`https://twitter.com/${social.twitter}`} target='_blank' rel='noopener'>
                und auf Twitter
              </a>
              {' '}
              gibt er Dir Infos und Tipps zu den aktuellsten Trends rund
              um die Themen SEO, Pagespeed und Web Performance.
            </p>
          </div>
        )
      }}
    />
  )
}

const bioQuery = graphql`
  query BioQuery {
    avatar: file(absolutePath: { regex: "/profile-daniel.jpg/" }) {
      childImageSharp {
        fixed(width: 50, height: 50) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    site {
      siteMetadata {
        author
        social {
          twitter
        }
      }
    }
  }
`

export default Bio
